export default {
  toastLifeTime: 100000,
  modules: {
    forgotpassword: "ForgotPassword",
    resetpassword: "ResetPassword",
    welcome: "Welcome",
    dashboard: "Dashboard",
    profile: "Profile",
    users: "Users",
    faculty: "Faculty",
    levelGrade: "LevelGrade",
    class: "Class",
    department: "Department",
    role: "Role"
  },
  routes: {
    home: "/",
    login: "/login",
    welcome: "/welcome",
    profile: "/profile",
    users: "/users",
    forgotpassword: "/forgotpassword",
    resetpassword: "/resetpassword",
    dashboard: "/dashboard",
    sessions: "/sessions",
    faculty: "/faculty",
    department: "/department",
    levelGrade: "/levelgrade",
    class: "/class",
    role: "/role",
    logout: "/logout"
  },
  networkErrorMessage: "Unable to reach server, check your network or contact your admin"
};
